import { drawer_catalog, running_metrics, running_workflows, templates_workflows, workflow_tabs } from './workflows.data.js';
import { start_workflow_templates, workflows_computed, workflows_methods } from './workflows.helpers.js';

export default {
  name: 'ComplyonWorkflows',
  data: () => ({
    workflow_tabs,
    running_metrics,
    running_workflows,
    templates_workflows,
    active_tab: 'running',
    drawer_catalog,
    active_drawer_key: null,
    active_workflow_item: null,
    show_start_workflow_modal: false,
    start_workflow_form: { template_id: 'supplier_onboarding', workflow_name: 'Acme Corp onboarding', owner: 'Responsible person' },
    start_workflow_templates
  }),
  computed: workflows_computed,
  methods: workflows_methods
};
